const firebaseConfig = {
    apiKey: "AIzaSyCnJ1zsSfUnFvu1VSyfVQyliwG9IXXHIss",
    authDomain: "money-counter-prod.firebaseapp.com",
    databaseURL: "https://money-counter-prod.firebaseio.com",
    projectId: "money-counter-prod",
    storageBucket: "money-counter-prod.appspot.com",
    messagingSenderId: "618258379544"
  };

  export default firebaseConfig;


// WEBPACK FOOTER //
// ./src/firebase-config-prod.js